import expressLogo from '../assets/expressjs.svg';
import api from '../assets/apipng.png';
import jwt from '../assets/jwt.png';
import met from '../assets/met.png';
import web from '../assets/web.png';
import lite from '../assets/Sqlite-square-icon.svg.png';
import dev from '../assets/dev-removebg-preview.png';
import post from '../assets/postman-icon.svg';
import action from '../assets/github-actions-logo-png_seeklogo-428028.png';
import nginx from '../assets/3030173.webp';
import AWS from '../assets/Amazon_Web_Services_Logo.svg.png';
import VPS from '../assets/8047704.png';

const devicon = (path) => `https://cdn.jsdelivr.net/gh/devicons/devicon/icons/${path}`;

export const skillLogos = {
  // Frontend
  HTML5: devicon('html5/html5-original.svg'),
  CSS3: devicon('css3/css3-original.svg'),
  JavaScript: devicon('javascript/javascript-original.svg'),
  TypeScript: devicon('typescript/typescript-original.svg'),
  React: devicon('react/react-original.svg'),
  'Next.js': devicon('nextjs/nextjs-original.svg'),
  Redux: devicon('redux/redux-original.svg'),
  'Tailwind CSS': devicon('tailwindcss/tailwindcss-original.svg'),
  Tailwind: devicon('tailwindcss/tailwindcss-original.svg'),
  Bootstrap: devicon('bootstrap/bootstrap-original.svg'),
  'Leaflet.js': 'https://leafletjs.com/docs/images/logo.png',

  // Backend
  'Node.js': devicon('nodejs/nodejs-original.svg'),
  'Express.js': expressLogo,
  NestJS: devicon('nestjs/nestjs-original.svg'),
  Python: devicon('python/python-original.svg'),
  PHP: devicon('php/php-original.svg'),
  Java: devicon('java/java-original.svg'),
  'Next.js API': devicon('nextjs/nextjs-original.svg'),
  'RESTful API': api,
  'JWT Auth': jwt,
  JWT: jwt,
  'Socket.io': devicon('socketio/socketio-original.svg'),
  Webhooks: web,
  Nodemailer: 'https://api.iconify.design/mdi/email-fast-outline.svg?color=%2364ffda',
  Twilio: 'https://api.iconify.design/simple-icons/twilio.svg?color=%23F22F46',
  'Stripe API': 'https://api.iconify.design/simple-icons/stripe.svg?color=%23635BFF',
  Selenium: devicon('selenium/selenium-original.svg'),
  'AI API Integrations': 'https://api.iconify.design/simple-icons/openai.svg?color=%23412991',
  'Weather APIs': met,
  'Meteo / Weather APIs': met,

  // Database
  MongoDB: devicon('mongodb/mongodb-original.svg'),
  PostgreSQL: devicon('postgresql/postgresql-original.svg'),
  MySQL: devicon('mysql/mysql-original.svg'),
  SQLite: lite,
  Redis: devicon('redis/redis-original.svg'),

  // Mobile
  Flutter: devicon('flutter/flutter-original.svg'),
  Dart: devicon('dart/dart-original.svg'),
  'React Native': devicon('reactnative/reactnative-original.svg'),
  Expo: 'https://cdn.simpleicons.org/expo/FFFFFF',
  Firebase: devicon('firebase/firebase-plain.svg'),

  // Tools & Design
  Git: devicon('git/git-original.svg'),
  GitHub: devicon('github/github-original.svg'),
  Figma: devicon('figma/figma-original.svg'),
  'VS Code': devicon('vscode/vscode-original.svg'),
  Postman: post,
  'Chrome DevTools': dev,
  'Android Studio': devicon('android/android-original.svg'),
  XAMPP: 'https://api.iconify.design/logos/xampp.svg',
  PyQt5: 'https://api.iconify.design/simple-icons/qt.svg?color=%2341CD52',
  PyInstaller: 'https://api.iconify.design/mdi/application-brackets-outline.svg?color=%23FFE873',

  // DevOps & Cloud
  Docker: devicon('docker/docker-original.svg'),
  Nginx: nginx,
  'GitHub Actions': action,
  AWS: AWS,
  'VPS Deployment': VPS,
};

export const getSkillLogo = (title) => skillLogos[title] || null;
